import { useCallback, useEffect, useRef, useState } from 'react';

const useUserInactivity = (enabled=false, delay=3000) => {
    const [isUserInactive, setUserInactive] = useState(false);
    const inactivityTimeout = useRef(null);

    const inactivity = useCallback(() => {
        clearTimeout(inactivityTimeout.current);
        inactivityTimeout.current = setTimeout(() => {
            setUserInactive(true);
        }, delay);
    }, [setUserInactive, delay]);

    useEffect(() => {
        if (enabled) {
            inactivity();
        } else {
            setUserInactive(false);
        }

        return () => clearTimeout(inactivityTimeout.current);
    }, [enabled, inactivity]);

    const handleInteractionStart = useCallback(() => {
        clearTimeout(inactivityTimeout.current);
        setUserInactive(false);
    }, []);

    const handleInteractionEnd = useCallback(() => {
        inactivity();
    }, [inactivity]);

    return { isUserInactive : enabled && isUserInactive, handleInteractionStart, handleInteractionEnd };
};

export default useUserInactivity;